export interface IUser {
    _id: number,
    name: string,
    email: string,
    notification: Array<string>,


}


export const initialUserObj: IUser = {
    _id: null,
    name: "",
    email: "",
    notification: [],
}
